module.exports = __webpack_public_path__ + "img/case-logo-29.a0cb2fc6.png";